__turbopack_context__.v({
  "container": "TextArea-module__X7C5KW__container",
  "inputLabel": "TextArea-module__X7C5KW__inputLabel",
  "styledInput": "TextArea-module__X7C5KW__styledInput",
  "styledInputDisabled": "TextArea-module__X7C5KW__styledInputDisabled",
  "styledInputFocus": "TextArea-module__X7C5KW__styledInputFocus",
});
